import { __awaiter, __generator } from "tslib";
import { defineComponent, ref } from 'vue';
import { useAuthStore } from '@/stores/authStore';
import router from '@/routes/index';
export default defineComponent({
    setup: function () {
        var _this = this;
        var email = ref('');
        var password = ref('');
        var auth = useAuthStore();
        var handleLogin = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, auth.login(email.value, password.value)];
                    case 1:
                        _a.sent();
                        console.log('Login successful');
                        if (auth.hasOrder()) {
                            router.push({ name: 'Order' });
                        }
                        else {
                            router.push({ name: 'Dashboard' });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        alert('Login failed');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        return {
            email: email,
            password: password,
            handleLogin: handleLogin,
        };
    },
});
